(() => {
  const COOKIE_NAME = 'papillon_age_verified';

  function hasCookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;

    return document.cookie
      .split(';')
      .map((cookie) => cookie.trim())
      .some((cookie) => cookie.startsWith(prefix));
  }

  function setSessionCookie(name, value) {
    const secure =
      window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie =
      `${encodeURIComponent(name)}=${encodeURIComponent(value)}` +
      `; Path=/; SameSite=Lax${secure}`;
  }

  function removePageLock() {
    document.documentElement.classList.remove(
      'papillon-age-gate-open',
      'papillon-age-pending'
    );

    document.body.classList.remove('papillon-age-gate-open');
  }

  function initializeAgeGate() {
    const gate = document.querySelector('[data-age-gate]');

    if (!gate) {
      removePageLock();
      return;
    }

    const cookieName =
      gate.dataset.cookieName || COOKIE_NAME;

    const confirmButton =
      gate.querySelector('[data-age-confirm]');

    const rejectButton =
      gate.querySelector('[data-age-reject]');

    const rejectUrl =
      gate.dataset.rejectUrl || 'https://www.nix18.nl/';

    if (hasCookie(cookieName)) {
      gate.remove();
      removePageLock();
      return;
    }

    gate.hidden = false;

    document.documentElement.classList.add(
      'papillon-age-gate-open'
    );

    document.body.classList.add(
      'papillon-age-gate-open'
    );

    document.documentElement.classList.remove(
      'papillon-age-pending'
    );

    requestAnimationFrame(() => {
      confirmButton?.focus();
    });

    confirmButton?.addEventListener('click', () => {
      setSessionCookie(cookieName, '1');

      gate.hidden = true;
      removePageLock();

      window.setTimeout(() => {
        gate.remove();
      }, 50);
    });

    rejectButton?.addEventListener('click', () => {
      window.location.href = rejectUrl;
    });

    gate.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAgeGate,
      { once: true }
    );
  } else {
    initializeAgeGate();
  }
})();